<template>
  <div class="companyProfile-container">
    <div class="allTitle">公司介绍</div>
    <div class="bottomBox">
      <div class="imgBox">
        <img src="../assets/pageImg/componyIcon.jpg" alt="">
      </div>
      <div class="contentBox">元魔凡成立于2015年，是公安数字化实训领域的解决方案供应商。公司凭借丰富的项目经验和各类前沿技术，将虚拟现实与人工智能两大核心技术进行融合、创新，潜心研究公安实训业务体系，通过数字化技术赋能，实现从理论到数字化实训应用，采用全新的手段助力民警提升实战能力。公司以“更完善、更实用、更高效”为愿景，打造新一代“公安数字化实训系统”。</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'companyProfile',
  data(){
    return{

    }
  }
}
</script>

<style lang="scss" scoped>
.companyProfile-container{
  padding-bottom:130px;
  // background:url('../assets/pageImg/companyProfile.jpg') no-repeat center;
  // background-size:100%;
  color:#fff;
  .bottomBox{
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    margin-top:28px;
    .imgBox{
      width: 167px;
      height: 82px;
      img{
        width:100%;
        height:100%;
      }
    }
    .contentBox{
      width:70%;
      line-height:46px;
      margin-left:76px;
    }
  }
}
@media screen and (max-width:767px) {
  .companyProfile-container{
    padding:42px 0px 72px 0px;
    box-sizing:border-box;
    .bottomBox{
      .imgBox{
        display: none;
      }
      .contentBox{
        width:100%;
        margin-left:0px;
        line-height:20px;
      }
    }
  }
}
</style>